import defaultExport from '@/store';
import * as log from 'loglevel';

log.setLevel(0);

const state = defaultExport.state;

export const gaSend = (option: string = '', url: string = '') => {
    if (typeof state.ga === 'function') {
        state.ga('send', 'event', 'Livechat', option, url);
    } else {
        log.error('ga is not defined');
    }
};
